<template>

  <div v-if="currentState.currentStatus != 'Ended'">
    <mdb-card class="mb-1 default-color-dark text-white">
      <mdb-card-body>
        <div v-if="currentState.currentStatus == 'Round Complete'">
          <h2>Round is Over!</h2>
          <div v-if="!game.isHost">
            <span class="spinner-grow text-warning"></span>
            Waiting for {{ game.host }} to start next round.
          </div>
          <mdb-btn v-if="game.isHost" @click="nextRound">Start Next Round</mdb-btn>
        </div>
        <div v-if="currentState.currentStatus == 'Cards Dealt'">
          <mdb-modal v-if="currentState.iAmModerator" class="animated slideInRight text-center" size="lg">
            <mdb-modal-body>
              <mdb-card>
                <mdb-card-header class="secondary-color">
                  <h3>You Are The Dealer - Ready to Start</h3>
                </mdb-card-header>
                <mdb-card-body>
                  <mdb-btn @click="starterCard">Flip Starting Card</mdb-btn>
                </mdb-card-body>
              </mdb-card>
            </mdb-modal-body>
          </mdb-modal>
          <div v-else>
            <h5>
              <span class="spinner-grow text-warning"></span>
              Cards Dealt -- waiting for {{ currentState.moderatorName }} to flip first card
            </h5>
          </div>
        </div>
        <mdb-row>
          <mdb-col class="text-left" col="4">
            <div v-if="currentState.lastDiscard && currentState.currentStatus != 'Round Complete'" class="playingCards">
              <h5 class="text-info">Up Card:</h5>
              <ul class="table">
                <li>
                  <ichi-card :card="currentState.lastDiscard"></ichi-card>
                  <div v-if="currentState.lastDiscard.newColor" class="text-danger">
                    <div v-if="currentState.lastDiscard.newColor == 'RED'" class="red text-white text-center h5">New
                      Color is Red
                    </div>
                    <div v-if="currentState.lastDiscard.newColor == 'BLUE'" class="blue text-white text-center h5">New
                      Color is Blue
                    </div>
                    <div v-if="currentState.lastDiscard.newColor == 'GREEN'" class="green text-white text-center h5">New
                      Color is Green
                    </div>
                    <div v-if="currentState.lastDiscard.newColor == 'YELLOW'" class="yellow text-dark text-center h5">
                      New Color is Yellow
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </mdb-col>
          <mdb-col class="text-left" col="4">
            <div v-if="currentState.currentStatus == 'Player Playing'">
              <div v-for="p in currentState.players" :key="p.playerId">
                <div>
                  <mdb-btn v-if="p.playerId != currentState.myPlayerId && p.numCards==1" color="danger" rounded size="sm"
                           @click="penalize(p)">Click if {{ p.name }} didn't say the magic word!
                  </mdb-btn>
                </div>
              </div>
            </div>
            <div v-if="currentState.currentStatus == 'Player Playing'">
              <div v-if="iAmInHotSeat">
                <h3>
                  <div class="animated bounce infinite text-warning">YOUR TURN!</div>
                </h3>
              </div>
              <div v-else>
                <h5>
                  {{ currentState.hotSeatPlayer }} is Playing
                  <span class="spinner-grow text-success"></span>
                </h5>
              </div>
              <span class="text-info">{{ currentState.upNext }} is the next player</span>
            </div>
          </mdb-col>
          <mdb-col col="4" class="text-right">
            <div class="text-warning">#Cards</div>
            <div v-for="p in currentState.players" :key="p.playerId">
              <span class="text-info">{{p.name}}</span> - {{p.numCards}}
            </div>
          </mdb-col>

        </mdb-row>

      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentState.currentStatus!='Round Complete' && currentState.currentStatus != 'Ended'">
      <mdb-card-body class="text-left">
        <div><span class="h5">My Hand</span>
          <mdb-btn icon="sort-numeric-down" rounded size="sm" @click="sortCards">Sort</mdb-btn>
        </div>
        <div class="playingCards">
          <div
            v-if="iAmInHotSeat && currentState.lastDiscard && currentState.lastDiscard.color == 'ANY' && !currentState.lastDiscard.newColor">
            You can play any card!
          </div>
          <div v-if="!executing">
            <div v-if="showTakeCard && iAmInHotSeat && currentState.currentStatus == 'Player Playing'">
              <mdb-btn icon="hand-holding" @click="takeCard">Take a New Card</mdb-btn>
            </div>
            <mdb-btn v-if="!showTakeCard && iAmInHotSeat" icon="arrow-right" @click="passHand">Pass</mdb-btn>
          </div>
          <ul class="table">
            <li v-for="(c,i) in myHand" :key="i">
              <a href="" @click.prevent="playCard(c)">
                <ichi-card :id="'ichi-card-'+i" :card="c" class="animated bounce"></ichi-card>
              </a>
            </li>
          </ul>
          <div class="text-info gp-end-wrap">Play a card by clicking/tapping it. If you can't play any cards, you must
            take a new one.
          </div>

        </div>

      </mdb-card-body>
    </mdb-card>

    <div style="clear:both;">&nbsp;</div>

    <mdb-card>
      <mdb-card-header>
        <h3>{{ currentState.currentStatus == 'Ended' ? 'Game Over - Final Scores' : 'Score Board' }}</h3>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-tbl>
          <mdb-tbl-head class="secondary-color">
            <tr>
              <th>Player</th>
              <th>Cards Left</th>
              <th class="text-right">Round Score</th>
              <th class="text-right">Score</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="p in currentState.players" :key="p.playerId">
              <td>
                {{ p.name }}
                <mdb-badge v-if="p.playerId == currentState.moderator" color="primary">Dealer</mdb-badge>
                <mdb-badge v-if="p.playerId == currentState.hotSeatPlayerId" color="warning">Current Player</mdb-badge>

              </td>
              <td>{{ p.numCards }}</td>
              <td class="text-right">
                <mdb-badge v-if="p.roundScore>0" class="mr-2" color="danger">Round Winner</mdb-badge>
                {{ p.roundScore }}
              </td>
              <td class="text-right">{{ p.score }}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <mdb-btn v-if="currentState.currentStatus=='Ended'" icon="house-leave" @click="startOver">Done</mdb-btn>
      </mdb-card-body>
    </mdb-card>

    <mdb-modal v-if="showColorSelector" class="text-left" size="lg">
      <mdb-modal-header :close="false" class="primary-color text-center text-white">
        <h5>Select New Color</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-btn color="blue" @click="selectColor('B')">Blue</mdb-btn>
        <mdb-btn color="red" @click="selectColor('R')">Red</mdb-btn>
        <mdb-btn color="green" @click="selectColor('G')">Green</mdb-btn>
        <mdb-btn color="yellow" @click="selectColor('Y')">Yellow</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbProgress,
  mdbRow,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import Avatar from "../common/Avatar";
import IchiCard from "./IchiCard";

export default {
  name: "ichi-play",
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  components: {
    Avatar,
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    mdbChipInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbBadge,
    mdbSpinner,
    mdbProgress,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    IchiCard
  },
  computed: {
    executing() {
      return this.$store.state.executing
    },
    gameStatus() {
      if (!this.game) return ""
      return this.currentState.currentStatus
    },
    myHand() {
      return this.currentState.myCards
    },
    iAmInHotSeat() {
      return this.currentState.iAmInHotSeat
    }
  },
  watch: {
    iAmInHotSeat(n, o) {
      if (n) this.showTakeCard = true
    },
    gameStatus(n, o) {
      if (n == "Round Complete") {
        this.currentState.myCards = []
        this.currentState.lastDiscard = null
      }
    }
  },
  data() {
    return {
      status: null,
      gameType: null,
      answers: [],
      retries: 0,
      showHostTools: false,
      iAmModerator: false,
      currentModerator: null,
      showTakeCard: false,
      holdCard: null,
      newColor: null,
      showColorSelector: false
    }
  },
  beforeDestroy() {
    this.keepPolling = false
  },
  mounted() {
    /*this.getMyHand()
     this.getStatus()*/
  },
  methods: {
    selectColor(color) {
      this.newColor = color
      this.holdCard.cardCode += color
      this.showColorSelector = false
      this.playCard(this.holdCard)
    },
    playCard(card) {
      if ((card.action == "WILD" || card.action == "DRAW4") && !this.newColor) {
        this.holdCard = card
        this.showColorSelector = true
        return
      }

      if (!this.currentState.iAmInHotSeat) {
        this.$notify.error({message: "Not Your Turn!", timeOut: 5000})
        return
      }
      if (!this.mayPlayCard(card)) {
        this.$notify.error({message: "You may not play that card!", timeOut: 5000})
        return
      }
      this.$store.dispatch("setExecuting", true)
      this.currentState.iAmInHotSeat = false //double clicks/taps causing problems?
      api.post("/ichi/playCard/" + this.game.sessionId, {accessToken: this.game.accessToken, card: card}).then(
        (results) => {
          let loc = this.myHand.indexOf(card)
          this.myHand.splice(loc, 1)
          this.holdCard = null
          this.newColor = null
          window.scrollTo(0, 0)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
          this.currentState.iAmInHotSeat = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    mayPlayCard(card) {
      let up = this.currentState.lastDiscard
      if (up.color == "ANY" && !up.newColor) return true
      if (up.color == "ANY" && card.color == up.newColor) return true
      if (card.color == up.color) return true
      if (card.type == "NUMBER" && up.type == "NUMBER" && card.number == up.number) return true
      if (card.type == "ACTION" && up.type == "ACTION" && card.action == up.action) return true
      if (card.color == "ANY") return true

      return false
    },
    starterCard() {
      this.$store.dispatch("setExecuting", true)
      api.post("/ichi/startCard/" + this.game.sessionId, {accessToken: this.game.accessToken}).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    sortCards() {
      this.myHand.sort((a, b) => (a.cardCode > b.cardCode ? 1 : -1))
    },
    takeCard() {
      this.$store.dispatch("setExecuting", true)
      api.post("/ichi/takeCard/" + this.game.sessionId, {accessToken: this.game.accessToken}).then(
        (results) => {
          this.showTakeCard = false
          this.currentState.myCards.push(results.data)
          /*this.$nextTick().then(() => {
            let el = document.getElementById("ichi-card-0")
            if (el) {
              el.classList.add("animated")
              el.classList.add("bounce")
            }
          })*/
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    passHand() {
      this.$store.dispatch("setExecuting", true)
      api.post("/ichi/pass/" + this.game.sessionId, {accessToken: this.game.accessToken}).then(
        (results) => {
          this.currentState.iAmInHotSeat = false
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    nextRound() {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/nextModerator/" + this.game.sessionId, {accessToken: this.game.accessToken}).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    penalize(player) {
      this.$store.dispatch("setExecuting", true)
      api.post("/ichi/penalize/" + this.game.sessionId, {
        playerId: player.playerId,
        accessToken: this.game.accessToken
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};

</script>

<style scoped>

@media screen and (max-width: 499px ) {
  .gp-fixed-action-btn {
    position: fixed;
    right: 5px;
    bottom: 10px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }

  .playingCards ul.table,
  .playingCards ul.hand,
  .playingCards ul.deck {
    list-style-type: none;
    padding: 0;
    margin: 0 0 .5em 0;
    position: relative;
    clear: both;
  }

  .playingCards ul.hand {
    margin-bottom: 1.5em;
  }

  .playingCards ul.table li,
  .playingCards ul.hand li,
  .playingCards ul.deck li {
    margin: 0;
    padding: 0;
    list-style-type: none;
    float: left;
  }

  .playingCards .card {
    display: inline-block;
    width: 3.5em;
    height: 5.8em;
    border: 1px solid #666;
    border-radius: .3em;
    -moz-border-radius: .3em;
    -webkit-border-radius: .3em;
    -khtml-border-radius: .3em;
    padding: .1em;
    margin: 0 .5em .5em 0;
    text-align: center;
    font-size: 1.2em;
    font-weight: normal;
    font-family: Arial, sans-serif;
    position: relative;
    background-color: #fff;
    -moz-box-shadow: .2em .2em .5em #333;
    -webkit-box-shadow: .2em .2em .5em #333;
    box-shadow: .2em .2em .5em #333;
  }

  .playingCards .card .rank,
  .playingCards .card .suit {
    display: block;
    line-height: 1;
    text-align: left;
  }

  .playingCards .card .rank {
  }

  .playingCards .card .suit {
    line-height: .7;
  }

}

@media screen and (min-width: 500px ) {

  .gp-fixed-action-btn {
    position: fixed;
    right: 35px;
    top: 100px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    padding: 15px 15px 15px 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }


  .playingCards ul.table,
  .playingCards ul.hand,
  .playingCards ul.deck {
    list-style-type: none;
    padding: 0;
    margin: 0 0 1.5em 0;
    position: relative;
    clear: both;
  }

  .playingCards ul.hand {
    margin-bottom: 3.5em;
  }

  .playingCards ul.table li,
  .playingCards ul.hand li,
  .playingCards ul.deck li {
    margin: 0;
    padding: 0;
    list-style-type: none;
    float: left;
  }

  .playingCards .card {
    display: inline-block;
    width: 5.3em;
    height: 7.6em;
    border: 1px solid #666;
    border-radius: .3em;
    -moz-border-radius: .3em;
    -webkit-border-radius: .3em;
    -khtml-border-radius: .3em;
    padding: .25em;
    margin: 0 .5em .5em 0;
    text-align: center;
    font-size: 1.2em;
    font-weight: normal;
    font-family: Arial, sans-serif;
    position: relative;
    background-color: #fff;
    -moz-box-shadow: .2em .2em .5em #333;
    -webkit-box-shadow: .2em .2em .5em #333;
    box-shadow: .2em .2em .5em #333;
  }

  .playingCards .card .rank,
  .playingCards .card .suit {
    display: block;
    line-height: 1;
    text-align: left;
  }

  .playingCards .card .rank {
  }

  .playingCards .card .suit {
    line-height: .7;
  }


}
</style>
